module.exports = __webpack_public_path__ + "static/main-83d5740d1903c939ee546ad7fe1b83e7.jpg";